import React, { useEffect, useState } from "react";
import { useLoader } from "../../Common/GeneralLoader/GeneralLoaderProvider";
import { getRecipientDetailsApi } from "../../../api/api";
import { drupalSettings } from "../../../utils/config";
import { postMessageToNativeWebView } from "../../../utils/nativeWebViewBridge";

export const SuccessAddRecipientStep = ({ setStep, payload, setPayload, setOpen, setFlow }) => {
  const [error, setError] = useState(false);
  const { showLoader, hideLoader } = useLoader(); // Destructure isLoading, showLoader, and hideLoader

  const formErrors = {
    technical_error:
      Drupal.t("Sorry, there was an error. Please try again later or reach out to support@nautzero.com."),
  };

  return (
    <>
      <div className="create-transfer-header">
        <h4 className="create-transfer-title"><span className="yellow">{Drupal.t("Success!")}</span></h4>
      </div>
      <div className="create-transfer-body-content">
        <div className="create-transfer-description">
          {Drupal.t("Your beneficiary has been saved.  Would you like to transfer them funds now?")}
        </div>
        <div className="create-transfer-actions">
          <button className="secondary__btn" type="submit" onClick={() => {
            (async () => {
              try {
                showLoader();
                console.log("payload", payload);
                // Fetch recipient details or perform any other action
                const response = await getRecipientDetailsApi({ yatchId: drupalSettings?.user?.yacht_id, recipientId: payload?.recipientId });
                setFlow("stored");
                setPayload({ flow: 'stored', recipientId: payload?.recipientId, recipientDetails: response }); // Update payload with the selected recipient details and ID

                // Move to the next step
                setStep(3.1);

              } catch (err) {
                console.error("Failed to fetch recipient details:", err);
                setError(formErrors?.technical_error);
              } finally {
                hideLoader();
              }
            })();
          }}>
            Yes, create transfer
          </button>
          <button
            className="primary__btn"
            type="submit"
            onClick={() => {
              postMessageToNativeWebView({
                type: "create-transfer:add-recipient-no-thanks",
                detail: {},
              });
              if (typeof window.destoryReactApp === "function") {
                window.destoryReactApp();
              }
            }}
          >
            No Thanks
          </button>
        </div>
        {error && (
          <div className="popup-has-error">
            <div className="error_messages">{error}</div>
          </div>
        )}
      </div>
    </>
  );
};
